import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldHelperProps, FieldInputProps, FieldMetaProps } from 'formik';
import useCountries from 'hooks/useCountries';
import { normalizeCountriesToSelect } from 'components/ui/composed/selects/utils';
import FormSelect from '../formSelect/FormSelect';

export interface CountryProps {
    refNumber?: string;
    label?: string;
    fieldProps: FieldInputProps<any>;
    fieldMeta?: FieldMetaProps<any>;
    fieldHelper?: FieldHelperProps<any>;
    icon?: boolean;
    required?: boolean;
    placeholder?: string;
    hideKeys?: boolean;
    disabled?: boolean;
    style?: React.CSSProperties;
    hideLabel?: boolean;
}

const CountrySelect: FC<CountryProps> = ({
    refNumber,
    label,
    fieldProps,
    icon,
    fieldMeta,
    required,
    fieldHelper,
    placeholder,
    hideKeys = true,
    disabled = false,
    hideLabel = false,
    style,
}) => {
    const { t } = useTranslation('common');
    const { countries } = useCountries();

    const countriesList = useMemo(() => normalizeCountriesToSelect(countries.list), [countries.list]);

    const labelText = hideLabel ? undefined : !label ? t('address.country') : label;

    return (
        <>
            {countries && (
                <FormSelect
                    refNumber={refNumber}
                    style={style}
                    disabled={disabled}
                    hideKeys={hideKeys}
                    required={required}
                    label={labelText}
                    placeholder={placeholder ?? ''}
                    selectOptions={countriesList}
                    fieldProps={fieldProps}
                    fieldMeta={fieldMeta}
                    fieldHelper={fieldHelper}
                />
            )}
        </>
    );
};

export default CountrySelect;
